import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const bannerThematicAddEditRolesRBAC = {
  pageID: '88fc9ea4eee062c8e7cdd7d64445423a',
  elementID: {
    ButtonSaveInformation: 'b113b5beee50e3cf95229cf11be85f69',
    ButtonSaveComponent: 'e5b47f768055230488552aef65974141',
  },
} as const

export const useRBACBannerThematicAddEditPage = createUseRBAC(
  bannerThematicAddEditRolesRBAC.elementID,
)

export type UseRBACBannerThematicAddEditPageType = ReturnType<
  typeof useRBACBannerThematicAddEditPage
>
